import React from "react";
import { formatMoney } from "../../config/publicConfig";

function RegistrationSummaryCard({
  language,
  IS_FREE,
  finalPrice,
  currency,
  btnNext,
  isValidatingDni,
  isValidatingEmail,
  dniStatusError,
  emailError,
  isValidatingCode,
  invitationCode,
  publicConfig,
  publicConfigError,
  isLoadingPublicConfig,
}) {
  const t = {
    EN: {
      fee: "Registration fee:",
      validating: "Validating...",
      next: "Next",
      invoiceBeforeEmail:
        "If you require an invoice, please request it by email as soon as you complete the purchase at",
      invoiceAfterEmail:
        "until August 30. Please make the request before the event, including your registration number and, if it is Invoice A, we also need Tax ID (CUIT) and legal business name. Thank you for your participation!",
    },
    ES: {
      fee: "Costo de inscripción:",
      validating: "Validando...",
      next: "Siguiente",
      invoiceBeforeEmail:
        "Si requerís Factura, te pedimos que la solicites vía email apenas concretes la compra a",
      invoiceAfterEmail:
        "hasta el 30 de agosto. Por favor realizá el pedido con anticipación al evento, indicando número de registro y si es Factura A, además, necesitamos CUIT y razón social. Gracias por tu participación!",
    },
  };

  const disabled =
    isValidatingDni ||
    isValidatingEmail ||
    !!dniStatusError ||
    !!emailError ||
    (!IS_FREE && isValidatingCode) ||
    (!IS_FREE &&
      !!invitationCode &&
      (!publicConfig || !!publicConfigError || isLoadingPublicConfig));

  const loading =
    isValidatingDni ||
    isValidatingEmail ||
    (!IS_FREE && isValidatingCode) ||
    (!IS_FREE && !!invitationCode && isLoadingPublicConfig);

  return (
    <div className="containerFlex">
      <div className="card flexBetween">
        <div>
          {!IS_FREE && (
            <>
              <h2>{t[language].fee}</h2>
              <div className="totalEmission">
                {formatMoney(finalPrice, currency)}
              </div>
              <p className="legal">
                {t[language].invoiceBeforeEmail}{" "}
                <a href="mailto:administracion@econojournal.com.ar">
                  administracion@econojournal.com.ar
                </a>{" "}
                <b>{t[language].invoiceAfterEmail}</b>
              </p>
            </>
          )}
        </div>

        <div>
          <button type="button" onClick={btnNext} disabled={disabled}>
            {loading ? t[language].validating : t[language].next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RegistrationSummaryCard;
